import React, { ReactNode, useEffect } from "react";

type FullscreenModalProps = {
  onClose: () => void;
  children: ReactNode;
};

export function FullscreenModal({ onClose, children }: FullscreenModalProps) {

  // close on ESC
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50">
      <div className="relative flex h-[90vh] w-[90vw] max-w-[600px] flex-col rounded-xl bg-white shadow-xl">
        {children}

        {/* close button in corner just in case */}
        <button
          type="button"
          className="absolute right-2 top-2 rounded bg-white/80 px-2 py-1 text-sm font-medium text-neutral-700 shadow"
          onClick={onClose}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
